export default __webpack_public_path__ + "static/media/favicon.6a6b0792.png";